export default "__VITE_ASSET__KB9vCXHc__"